import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { signals } from '../../data/snakInsights';

/** Quantitative + qualitative evidence combined into actionable signals. */
export function SignalsPanel() {
  return <div className="grid gap-[clamp(0.6rem,1vw,0.9rem)] md:grid-cols-2" data-id="element-152" data-mp="egrqn0i4q1et">
      {signals.map((s, i) => <motion.article key={s.signal} initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: i * 0.08,
      duration: 0.45,
      ease: [0.23, 1, 0.32, 1]
    }} className="flex flex-col rounded-2xl bg-white p-[clamp(1.1rem,1.8vw,1.6rem)] ring-1 ring-[var(--fg)]/[0.07]" data-id="element-153" data-mp="jfmfok6owm7d" data-mpi={i}>
          <span className="font-mono text-[0.66rem] tracking-[0.14em] text-[var(--brand)]" data-id="element-154" data-mp="127famk5bkhhq">SIGNAL 0{i + 1}</span>
          <h3 className="mt-2 text-[clamp(1.05rem,1.6vw,1.45rem)] font-extrabold leading-tight tracking-[-0.025em] text-[var(--fg)]" data-id="element-155" data-mp="3hytg0njn3usq">{s.signal}</h3>
          <p className="mt-3 rounded-lg bg-[var(--surface)] px-3 py-2 text-[clamp(0.72rem,0.9vw,0.84rem)] font-medium text-[var(--fg)]" data-id="element-156" data-mp="1nvo6z2xs2b8t">{s.evidence}</p>
          <p className="mt-auto flex gap-2 pt-4 text-[clamp(0.76rem,0.95vw,0.9rem)] leading-snug text-[var(--muted)]" data-id="element-157" data-mp="1ixwadvm6u0ya">
            <ArrowRightIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-[var(--brand)]" aria-hidden="true" data-id="element-158" data-mp="1wu9jagcnou15" />
            <span data-id="element-159" data-mp="1rzm4583jlbz8">
              <span className="font-semibold text-[var(--fg)]" data-id="element-160" data-mp="26ua5qb5tnq9k">Next step: </span>
              {s.implication}
            </span>
          </p>
        </motion.article>)}
    </div>;
}